import { Skeleton } from '@/components/ui/skeleton';

const SidebarSkeleton = () => (
  <div className="hidden fixed min-[1920px]:absolute inset-y-0 z-10 min-h-svh h-full w-[303px] bg-whit border-r border-border lg:block">
    <div className="flex h-full w-full flex-col bg-sidebar">
      <div className="py-6 px-4">
        <Skeleton className="h-12 w-full rounded-sm" />
      </div>
      <div className="flex min-h-0 flex-1 flex-col gap-2 py-6 px-4">
        <Skeleton className="h-[62px] w-full rounded-lg" />
        <Skeleton className="h-[140px] w-full rounded-lg" />
      </div>
    </div>
  </div>
);

export { SidebarSkeleton };
